jQuery(function($){
	$('form.cs-protected-download').click(function(e){
		e.preventDefault();

		let form = $(this);

		form.removeClass('loaded').addClass('loading')

		let data = {ajax: 'true'};
		$.each(form.find('input'), function(){
			data[$(this).attr('name')] = $(this).val();
		});

		$.post('/wp-admin/admin-ajax.php', data, function(result) {
			console.log(result);
			form.removeClass('loading').addClass('loaded')
			form.append('<input type="hidden" name="temp" value="' + JSON.parse(result).temp + '" />').submit();
		});
	});
});